import React from 'react';
import { classNames } from './classNames';

export type DropdownDirection = 'down' | 'up';

export interface DropdownProps extends React.HTMLAttributes<HTMLDivElement> {
  direction?: DropdownDirection;
}

const Dropdown = React.forwardRef<HTMLDivElement, DropdownProps>(({
  direction = 'down',
  className,
  children,
  ...props
}, ref) => (
  <div
    ref={ref}
    className={classNames(direction === 'up' ? 'dropup' : 'dropdown', className)}
    {...props}
  >
    {children}
  </div>
));

Dropdown.displayName = 'Dropdown';

export default Dropdown;
